/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 广告位通用组件
 */
import platform from '@/shared/utils/platform';
import { defaultGeoInfo } from '@/constant/system';
import { appEnv } from '../index';
import { h5ComponentsType } from './types';

// eslint-disable-next-line max-len
export const getAdvData = async (advMasterId: string, options: Dictionary = {}): Promise<any> => new Promise<any>((resolve, reject) => {
  import(
    /* webpackChunkName: "h5-components-api" */'@hb/h5-components'
  ).then((res) => {
    const { advMasterApi } = res.default as h5ComponentsType;
    /** 微信小程序无定位权限，直接使用默认定位信息 */
    if (platform.isWechatMini) {
      options.geo = defaultGeoInfo;
    }
    advMasterApi.getBannerInfos([advMasterId], appEnv, options).then((adxData) => {
      if (adxData.adm && adxData.adm.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        adxData.adm.forEach((imp) => {
          /** creative 非空数组 才命中任务 */
          if (imp.impid === advMasterId && imp.creative && imp.creative.length > 0) {
            resolve(imp);
          }
        });
      } else {
        reject();
      }
    }).catch(() => {
      reject();
    });
  }).catch(() => {
    reject();
  });
});
